import { IMonoOccurrenceOptions } from "../../../../../core/services/mono-occurrence.service"; 
import { IMonoOccurrence } from "../../../../../core/services/mono-occurrence.service";
import { IComponentController } from "angular";
import { IEcranDetailsResourcesEntite } from "../../../../../core/resources/ecran-details.resource";
import { IFormulaireClass } from "../../../../../core/services/formulaire/formulaire.service";
import { IFormulaireItemClass } from "../../../../../core/services/formulaire/formulaire-item.service";
import { IMenuItemActionTelechargementClass } from "../../../../../core/services/menu/menu-item-action-telechargement.service";


interface IPageRr2033 extends IComponentController {
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    monoOccurrence: IMonoOccurrence;
    valeursEcran: any;
}

/* @ngInject */
export default function Rr2033Controller(
    ecranDetails: IEcranDetailsResourcesEntite,
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    MenuItemActionTelechargement: IMenuItemActionTelechargementClass
) {
    const vm: IPageRr2033 = this;
    vm.valeursEcran = ecranDetails.valeurs;

    vm.monoOccurrenceOptions = {
        noId: true,
        fonctions: {
            pagination: false,
            nouveau: false,
            suiviModification: false,
            filtrer: false,
            recherche: false,
            exportation: false,
            selectionnerTri: false,
            supprime: false,
            boutonEnregistrerHaut: false,
        },
        formulaire: new Formulaire('G_LBL_MSL_FILTRE_TITRE', [
            new FormulaireItem('demcleint', {
                largeur: 30
            }),
            new FormulaireItem('unpcleint', {
                largeur: 30,
                default: vm.valeursEcran.unpcleint
            }),
            new FormulaireItem('ppacleintdeb', {
                largeur: 30
            }),
            new FormulaireItem('ppacleintfin', {
                largeur: 30
            })
        ]),
        menus: [
            new MenuItemActionTelechargement(
                'G_LBL_BTN_GENERER',
                'BOUTGENPDF',
                () => {
                    return {
                        demcleint: vm.monoOccurrence.data.demcleint,
                        unpcleint: vm.monoOccurrence.data.unpcleint,
                        ppacleintdeb: vm.monoOccurrence.data.ppacleintdeb,
                        ppacleintfin: vm.monoOccurrence.data.ppacleintfin,
                        pp: vm.monoOccurrence.data.ppacleintfin
                    };
                },
                {
                    iconButton: false,
                    icon: 'download',
                    class: 'md-raised ex-button-action',

                    disabled() {
                        return !vm.monoOccurrence.data.demcleint
                            || !vm.monoOccurrence.data.unpcleint
                            || !vm.monoOccurrence.data.ppacleintdeb
                            || !vm.monoOccurrence.data.ppacleintfin;
                    }
                }
            )
        ]
    };
}
